export enum SurgeryConfirmActionEnum {
	CONFIRM = 1,
	CANCEL = 2,
}

export type PostSurgeryConfirmParams = {
	scheduleCode: number;
	option: SurgeryConfirmActionEnum;
};

export interface PostSurgeryConfirm {
	post: (params: PostSurgeryConfirmParams) => Promise<unknown>;
}
